import React, { ComponentProps, PropsWithChildren } from 'react'

import { bemJoin, classNames } from '@app/lib/bem'
import { MergeProps } from '@app/lib/types'

import './PillBadge.scss'

type PillBadgeProps = MergeProps<
  ComponentProps<'span'>,
  {
    icon?: React.ReactNode
    color?: 'neutral' | 'success'
    size?: 'sm' | 'md'
  }
>

export const PillBadge = ({
  icon,
  color = 'neutral',
  size = 'md',
  className,
  children,
  ...rest
}: PropsWithChildren<PillBadgeProps>) => {
  const b = bemJoin('pill-badge')

  return (
    <span
      {...rest}
      className={classNames(
        b({
          [color]: true,
          [size]: true
        }),
        className
      )}
    >
      {icon && <div className={b('icon')}>{icon}</div>}
      {children}
    </span>
  )
}
